// extracted by mini-css-extract-plugin
module.exports = {"cta":"OpenOnClick_cta__D3TyJ"};